"use strict";
export const filterToLabel = {
  job_titles: "Job Titles",
  skills: "Skills",
  industries: "Industries",
  years_of_experience: "Years of Experience",
  location: "Location"
};
